import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found - David Seibold</title>
        <meta name="robots" content="noindex" />
        <meta
          name="description"
          content="The page you're looking for doesn't exist. Return to David Seibold's portfolio home page."
        />
      </Helmet>
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900 text-center px-4">
        <img
          src="/img/not-found-cat.png"
          alt="A confused cat looking for the missing page"
          className="w-56 h-auto mb-8 rounded-lg"
        />
        <h1 className="text-6xl font-extrabold text-gradient mb-4">404</h1>
        <p className="text-2xl text-gray-800 dark:text-brand-cream mb-8">
          Oops! The page you're looking for doesn't exist.
        </p>
        <p className="text-lg text-gray-700 dark:text-brand-cream mb-8">
          It looks like you might be lost. Don't worry, we'll help you find your
          way back.
        </p>
        <Link
          to="/"
          className="bg-brand-gold text-black font-bold px-6 py-3 rounded-full text-lg hover:bg-brand-gold/90 transition shadow-lg hover:shadow-glow"
        >
          Go to Home
        </Link>
      </div>
    </>
  );
};

export default NotFound;
